
import { Component, Vue } from 'vue-property-decorator'
import { videoPage } from '@/api'
import { IVideoType } from '@/types/type'
import HeaderSearch from '@/components/componentWap/HeaderSearch.vue'
@Component({
    name: 'VideoList',
    components: {
        HeaderSearch
    }
})
export default class extends Vue {
    private loading = false
    private page = {
        pageSize: 8,
        pageNum: 1,
        total: 0
    }
    private dataList: IVideoType[] = []
    private isShowMore = false
    private async initData() {
        this.loading = true
        const params = {
            pageSize: this.page.pageSize,
            pageNum: this.page.pageNum
        }
        const res = await videoPage(params).catch(() => this.loading = false)
        this.dataList = this.dataList.concat(res.data.list)
        this.page.total = res.data.total
        this.isShowMore = this.page.total / (this.page.pageNum * this.page.pageSize) > 1
        this.loading = false
    }
    // 加载更多
    private addMore() {
        if (!this.isShowMore) return
        this.page.pageNum++
        this.initData()
    }
    // 详情
    private goDetail(id: string) {
        this.$jump(`/Video/VideoDetail?videoId=${id}`)
    }
    created() {
        this.initData()
    }
    private handleScroll () {
        const scrollTop = document.documentElement.scrollTop
        const scrollHeight = document.documentElement.scrollHeight
        const clientHeight = document.documentElement.clientHeight
        if (scrollTop + clientHeight >= scrollHeight) {
            this.addMore()
        }
    }
	mounted () {
    	window.addEventListener('scroll', this.handleScroll)
    } 
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}

